module.exports = __webpack_public_path__ + "media/src/img/line-pink-a4921321406196dcd630168baff22586.svg";